// Get Acquisition Channel List
export const GET_ACQUISITION_CHANNEL_LIST = "GET_ACQUISITION_CHANNEL_LIST";
export const GET_ACQUISITION_CHANNEL_LIST_SUCCESS =
  "GET_ACQUISITION_CHANNEL_LIST_SUCCESS";
export const GET_ACQUISITION_CHANNEL_LIST_FAILURE =
  "GET_ACQUISITION_CHANNEL_LIST_FAILURE";

// Get Acquisition Channel data
export const GET_ACQUISITION_CHANNEL_DATA = "GET_ACQUISITION_CHANNEL_DATA";
export const GET_ACQUISITION_CHANNEL_DATA_SUCCESS =
  "GET_ACQUISITION_CHANNEL_DATA_SUCCESS";
export const GET_ACQUISITION_CHANNEL_DATA_FAILURE =
  "GET_ACQUISITION_CHANNEL_DATA_FAILURE";

// Create Acquisition Channel
export const CREATE_ACQUISITION_CHANNEL = "CREATE_ACQUISITION_CHANNEL";
export const CREATE_ACQUISITION_CHANNEL_SUCCESS =
  "CREATE_ACQUISITION_CHANNEL_SUCCESS";
export const CREATE_ACQUISITION_CHANNEL_FAILURE =
  "CREATE_ACQUISITION_CHANNEL_FAILURE";

// Update Acquisition Channel
export const UPDATE_ACQUISITION_CHANNEL = "UPDATE_ACQUISITION_CHANNEL";
export const UPDATE_ACQUISITION_CHANNEL_SUCCESS =
  "UPDATE_ACQUISITION_CHANNEL_SUCCESS";
export const UPDATE_ACQUISITION_CHANNEL_FAILURE =
  "UPDATE_ACQUISITION_CHANNEL_FAILURE";

// Delete Acquisition Channel
export const DELETE_ACQUISITION_CHANNEL = "DELETE_ACQUISITION_CHANNEL";
export const DELETE_ACQUISITION_CHANNEL_SUCCESS =
  "DELETE_ACQUISITION_CHANNEL_SUCCESS";
export const DELETE_ACQUISITION_CHANNEL_FAILURE =
  "DELETE_ACQUISITION_CHANNEL_FAILURE";
